import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const codeViewAppBuilder = DataRouterApplicationBuilder.create('code-view')
